var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExclamationCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "16.67px",
    height: "16.67px",
    viewBox: "0 0 127.000000 127.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,127.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M545 1264 c-242 -38 -450 -220 -521 -459 -25 -82 -25 -258 0 -340 63 -210 231 -378 441 -441 82 -25 258 -25 340 0 210 63 378 231 441 441 25 82 25 258 0 340 -62 208 -232 379 -436 439 -56 17 -210 28 -265 20z m207 -85 c249 -52 438 -286 438 -544 0 -306 -249 -555 -555 -555 -306 0 -555 249 -555 555 0 252 179 482 423 541 66 16 180 17 249 3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592 934 c-18 -12 -22 -25 -22 -66 0 -83 22 -282 33 -295 12 -17 52 -17 64 0 11 13 33 212 33 295 0 41 -4 54 -22 66 -12 9 -32 16 -43 16 -11 0 -31 -7 -43 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580 450 c-28 -28 -26 -81 3 -108 49 -46 127 -12 127 56 0 43 -30 72 -75 72 -22 0 -43 -8 -55 -20z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationCircle);
export default __webpack_public_path__ + "static/media/ExclamationCircle.35742202238c0f114ce918e9765f8069.svg";
export { ForwardRef as ReactComponent };